import type {
  CreateRenewalSubmissionResponse,
  CreateRenewalSubmissionSpaPayload,
} from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

export const createRenewal = async (
  data: CreateRenewalSubmissionSpaPayload,
  submissionId: string,
): Promise<CreateRenewalSubmissionResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: `submissions/${submissionId}/renewals`,
    data,
  });
  const response = await axios<CreateRenewalSubmissionResponse>(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  return response.data;
};
